/* TPS — Frequently Bought Together repositioner
   Moves the Code Black Belt "Make it a bundle to SAVE more!" widget
   (.cbb-frequently-bought-container) to sit directly below the
   "Chat with us on WhatsApp" band (.tpswa) inside the product info column,
   on every product template, mobile + desktop.

   The FBT app injects its container asynchronously as a sibling of .product
   inside .page-width, and re-renders on variant change — a long product
   description then pushes it to the very bottom of the page. This script
   relocates it the moment it appears and keeps it in place across re-renders.

   Fail-safe (never throws), idempotent (runs once), loop-safe (only moves
   when not already positioned). */
(function () {
  if (window.__tpsFbtPos) return;
  window.__tpsFbtPos = true;

  var FBT_SEL = '.cbb-frequently-bought-container';
  var WA_SEL  = '.tpswa';

  function place() {
    try {
      var fbt = document.querySelector(FBT_SEL);
      var wa  = document.querySelector(WA_SEL);
      if (!fbt || !wa) return;
      // Already directly after the WhatsApp band — nothing to do (loop guard).
      if (wa.nextElementSibling === fbt) return;
      wa.parentNode.insertBefore(fbt, wa.nextSibling);
      fbt.setAttribute('data-tps-placed', '1');
    } catch (e) { /* no-op */ }
  }

  function init() {
    place();
    try {
      var scope = document.querySelector('main') || document.body;
      var t;
      var mo = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(place, 150);
      });
      mo.observe(scope, { childList: true, subtree: true });
    } catch (e) { /* initial place still applied */ }

    // Safety net for late async injection in the first ~20s.
    try {
      var n = 0;
      var iv = setInterval(function () {
        place();
        if (++n > 40) clearInterval(iv);
      }, 500);
    } catch (e) { /* no-op */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', place);
})();
